/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var radio = require('ES/lib/radio');
var _ = require('ES/lib/lodash');

var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var HorizontalFields = require('ES/widgets/HorizontalFields');
var FormUtils = require('../../../../../utils/FormUtils');

module.exports = dd.createClass({

	__onSubmit: function(data){
		var event = _.cloneDeep(this.props.event);
		var flight = this.props.data;
		var onCancel = this.props.onCancel;

		if(!_.isArray(event.Flight)){
			event.Flight = [];
		}
		if(!flight || flight.id < 1){
			flight = {id: 0, eid: event.eid};
			event.Flight.push(flight);
		}
		_.each(event.Flight, function(f){
			if(f.id == flight.id){
				f.groupcode = data.groupcode;
				f.description = data.description;
				f.agent = data.agent;
				f.cost = FormUtils.floatOr0(data.cost);
				f.legs = _.map(FormUtils.extractIdsFromKeys(data, /^leg_(\-?[0-9]+)_/), function(id){
					var leg = {id: id > 0 ? id : 0};
					leg.legto = data['leg_' + id + '_legto'];
					//leg.legcost = FormUtils.floatOr0(data['leg_' + id + '_legcost']);
					leg.legfrom = data['leg_' + id + '_legfrom'];
					leg.legseat = data['leg_' + id + '_legseat'];
					leg.legleave = data['leg_' + id + '_legleave'];
					leg.legarrive = data['leg_' + id + '_legarrive'];
					//leg.legticket = data['leg_' + id + '_legticket'];
					leg.legcarrier = data['leg_' + id + '_legcarrier'];
					leg.legflightnum = data['leg_' + id + '_legflightnum'];
					return leg;
				});
			}
		});
		radio('save_Event').broadcast(event);
		if(_.isFunction(onCancel)){
			onCancel();
		}
	},
	__onDelete: esUtils.wrapPreventDefault(function(){
		var event = _.cloneDeep(this.props.event);
		var flight = this.props.data;
		var onCancel = this.props.onCancel;

		if(flight && flight.id > 0){
			event.Flight = _.reject(event.Flight, function(h){
				return flight.id == h.id;
			});
			radio('save_Event').broadcast(event);
		}
		if(_.isFunction(onCancel)){
			onCancel();
		}
	}),
	render: function(){
		return DaForm(_.assign({onSubmit: this.__onSubmit, onDelete: this.__onDelete}, this.props));
	}
});

var DaForm = dd.createClass({
	mixins: [FormMixin],
	getInitialValues: function(props){
		var flight = props.data;
		if(!flight || flight.id < 1){
			return null;
		}
		var data = {
			groupcode: flight.groupcode,
			description: flight.description,
			agent: flight.agent,
			cost: flight.cost
		};
		_.each(flight.legs, function(leg){
			data['leg_' + leg.id + '_legto'] = leg.legto;
			//data['leg_' + leg.id + '_legcost'] = leg.legcost;
			data['leg_' + leg.id + '_legfrom'] = leg.legfrom;
			data['leg_' + leg.id + '_legseat'] = leg.legseat;
			data['leg_' + leg.id + '_legleave'] = leg.legleave;
			data['leg_' + leg.id + '_legarrive'] = leg.legarrive;
			//data['leg_' + leg.id + '_legticket'] = leg.legticket;
			data['leg_' + leg.id + '_legcarrier'] = leg.legcarrier;
			data['leg_' + leg.id + '_legflightnum'] = leg.legflightnum;
		});
		return data;
	},
	buildFields: function(){
		var Displaylists = this.props.Displaylists;
		var data = this.state.data || {};
		var schema = {
			description: {label: 'Description'},
			agent: {label: 'Conf #'},
			cost: {
				label: 'Cost',
				type: 'text',
				validate: FormUtils.v.blankOr(FormUtils.v.currency)
			}
		};
		var ids = FormUtils.extractIdsFromKeys(data, /^leg_(\-?[0-9]+)_/);
		_.each(ids, function(id){
			schema['leg_' + id + '_legto'] = {label: 'To'};
//			schema['leg_' + id + '_legcost'] = {
//				label: 'Cost',
//				type: 'text',
//				validate: FormUtils.v.blankOr(FormUtils.v.currency)
//			};
			schema['leg_' + id + '_legfrom'] = {label: 'From'};
			schema['leg_' + id + '_legseat'] = {label: 'Seat'};
			schema['leg_' + id + '_legleave'] = {
				label: 'Depart',
				type: 'date',
				pick_time: true
			};
			schema['leg_' + id + '_legarrive'] = {
				label: 'Arrive',
				type: 'date',
				pick_time: true
			};
			//schema['leg_' + id + '_legticket'] = {label: 'Ticket'};
			schema['leg_' + id + '_legcarrier'] = {
				label: 'Carrier',
				type: 'select',
				options: _.object(_.map(_.get(Displaylists, ["universal", "aircarriers"]), function(carrier){
					return [carrier, carrier];
				}))
			};
			schema['leg_' + id + '_legflightnum'] = {label: 'Flight number'};
		});
		_.each(schema, function(field, name){
			if(!_.has(field, 'type')){
				field.type = 'text';
			}
			if(!_.has(field, 'validate')){
				field.validate = FormUtils.optional;
			}
		});
		return schema;
	},
	__newLeg: esUtils.wrapPreventDefault(function(){
		var data = this.state.data || {};
		var id = -1;
		while(_.has(data, 'leg_' + id + '_legto')){
			id -= 1;
		}
		data['leg_' + id + '_legto'] = 'new';//just make one field then it'll pick up that there is a new leg
		this.setState({data: data});
	}),
	__deleteLeg: function(id){
		var self = this;
		return esUtils.wrapPreventDefault(function(){
			var data = self.state.data || {};
			self.setState({data: FormUtils.filterKeysOut(data, new RegExp('^leg_' + id))});
		});
	},
	render: function(){
		var fields = this.buildFields(this.Displaylists);
		var errors = this.state.errors || {};

		var flight = this.props.data;
		var onCancel = this.props.onCancel;
		var onDelete = this.props.onDelete;
		var legCount = FormUtils.extractIdsFromKeys(fields, /^leg_(\-?[0-9]+)_/).length;
		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput,
				label_size: 2,
				layout: [
					['description'],
					['agent', 'cost']
				]
			}),
			dd.h3({style: {margin: '2em 0 0.5em 0'}},
				(legCount + ' Leg' + ((legCount != 1) ? 's' : '')),
				dd.button({className: 'btn btn-default btn-sm pull-right', onClick: this.__newLeg}, dd.i({className: 'fa fa-plus'}), ' add leg')
			),
			dd.hr(),
			dd.div({className: 'clearfix'}),
			dd.div(null,
				_.map(FormUtils.extractIdsFromKeys(fields, /^leg_(\-?[0-9]+)_/).sort(), function(id){
					var prefix = 'leg_' + id + '_';
					return dd.div({key: id},
						HorizontalFields({
							fields: fields,
							errors: errors,
							buildInput: this._form_buildInput,
							label_size: 2,
							layout: [
								[dd.a({href: '#', className: 'pull-right', onClick: this.__deleteLeg(id)}, 'delete leg')],
								[prefix + 'legfrom', prefix + 'legto'],
								[prefix + 'legleave'],
								[prefix + 'legarrive'],
								[prefix + 'legcarrier'],
								[prefix + 'legflightnum', prefix + 'legseat']
							]
						}),
						dd.hr()
					);
				}, this)
			),
			HorizontalFields.FormButtons({
				label_size: 2,
				scale: 'md',
				onCancel: onCancel,
				submit_btn_text: flight && flight.id > 0 ? 'Save' : 'Add',
				onDelete: flight && flight.id > 0 ? onDelete : null,
				right_align_buttons: true
			})
			//TODO dd.a({href: '#', className: 'pull-right', style: {fontSize: 14, marginTop: 4}}, 'copy from venue')
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/travel/FlightForm.js